module.exports = __webpack_public_path__ + "static/product-4-6cf343b7afe4cb573f3e04317f05892b.png";